import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-3xl my-2xl" }
const _hoisted_3 = { class: "text-3xl my-2xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "my-md" }, "o", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_ctx.isFetchingAuthUser)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createBlock(_component_Grid, {
        key: 1,
        size: "md"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PageTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.trans("general.press_access")), 1)
            ]),
            _: 1
          }),
          (_ctx.authUser && _ctx.authUser.pressMediasIds)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.trans("general.already_access")), 1),
                _createVNode(_component_Button, {
                  text: _ctx.trans('general.come_back_to'),
                  size: "lg",
                  to: { name: 'Home' },
                  color: 'accent'
                }, null, 8, ["text"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.trans("general.get_access_and_more_information")), 1),
                (!_ctx.authUser)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      text: _ctx.trans('general.sign_in_with_an_account'),
                      size: "lg",
                      color: "accent",
                      href: _ctx.loginLink
                    }, null, 8, ["text", "href"]))
                  : _createCommentVNode("", true),
                (_ctx.authUser && !_ctx.authUser.pressMediasIds)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      text: _ctx.trans('general.do_you_have_a_code'),
                      size: "lg",
                      color: "accent",
                      href: _ctx.codeLink,
                      target: "_blank"
                    }, null, 8, ["text", "href"]))
                  : _createCommentVNode("", true),
                _hoisted_4,
                _createVNode(_component_Button, {
                  text: 
          _ctx.authUser
            ? _ctx.trans('general.apply_for_press_permits')
            : _ctx.trans('general.request_a_press_account')
        ,
                  size: "lg",
                  to: { name: 'Register' }
                }, null, 8, ["text"])
              ], 64))
        ]),
        _: 1
      }))
}